<div class="expandableWidget" [ngClass]="{ expanded: contentExpanded(), onlyChevron: onlyChevronExpands() }">
    <div class="expandoHeader">
        <div
            class="interactiveHeader"
            [class.no-right-margin]="displayFullWidthHeader()"
            [class.centered-chevron]="centerChevron()"
            [style.width.%]="displayFullWidthHeader() ? 100 : null"
            (click)="toggleExpandedContent($event)"
        >
            <div class="expandableWidgetMainContentContainer" [style.width.%]="displayFullWidthHeader() ? 100 : null">
                <div class="mainContentStretcher" [class.expansionAllowed]="isExpandable()">
                    <ng-content select=".mainContent" />
                </div>
            </div>
            <button class="button noButton" [class.centered]="centerChevron()" (click)="toggleExpandedContent($event, true)">
                <i
                    class="icon fas"
                    [class.expansionAllowed]="isExpandable()"
                    [ngClass]="{
                        expanded: contentExpanded(),
                        'fa-chevron-right': !contentExpanded() || level() === 0,
                        'fa-chevron-down': contentExpanded() && level() !== 0,
                    }"
                ></i>
            </button>
        </div>
        <div class="nonInteractiveHeader">
            <ng-content select=".nonInteractiveContent" />
        </div>
    </div>

    @if (contentExpanded()) {
        <div class="expandableWidgetContentContainer" [class.withMargin]="applyContentMargin()">
            <ng-content select=".expandableContent" />
        </div>
    }
</div>
